import sort from './sort.js';
export default function sortArraysByIndex(index) {
    return function sortByIndex(arrA, arrB) {
        const valueA = arrA[index];
        const valueB = arrB[index];
        return sort(valueA, valueB);
    };
}
//# sourceMappingURL=sort-arrays-by-index.js.map